import React from 'react'

const cardStyle = {
    backgroundColor: "#F0F2FD",
    borderRadius: "2.5rem",
    padding: "3rem 3rem 5rem",
    minHeight: "20rem",
}


const liButtonStyle = {
    background: "linear-gradient(120.13deg, #4A67FF -3.15%, #3956F0 8.51%, #798EFF 71.07%, #8496F4 102.88%)",
    border: "none",
    borderRadius: "2.5rem",
    padding: "1.125rem 3.125rem",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: "700",
    lineHeight: "1.594rem",
    maxWidth: "17.75rem",
    width: "100%",
    maxHeight: "4.625rem",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    alignItems: "center",
    position: "relative",
    top: "-2.5rem",
    left: "50%",
    transform: "translateX(-50%)",
    cursor: "pointer",
}

const LiButton = ({ link }) => {
    return <button style={liButtonStyle} className="registerButtonAnimation "
        onClick={() => window.open(link, '_blank')}
    ><img src={require('../../../images/landingpage/linkedin-logo.svg')} alt='Linkedin Logo' />
    </button>
}

const TEAM_SECTION = [
    {
        img: require('../../../images/landingpage/team-img1.png'),
        title: 'Matt Clark ACMA,',
        designation: "Co-founder & CFO",
        points: [
            'Experienced CFO of VC-backed technology companies (both US and UK)',
            'Strong commercial viewpoint, has previously also acted as COO'
        ],
        link: 'https://www.linkedin.com/in/matt-clark-91ba80a4/'
    },
    {
        img: require('../../../images/landingpage/team-img2.png'),
        title: 'Mark Bernstein ACA,',
        designation: "Co-founder & CEO",
        points: [
            'Experienced technology sector growth manager/CEO/NED/NEC',
            'Qualified chartered accountant with EY 30 years on listed and private company boards',
            'IPO experience (four companies to IPOs on LSE/AIM); two from startup to IPO;(largest to $1bn)',
            'In previous startups  taken equity investment from IBM, Motorola, BT, Sky, Dixons',
            'Start-ups/scaleups and 25+ acquisitions, disposals & exits',
            'Experienced angel investor '
        ],
        link: 'https://www.linkedin.com/in/markbernstein/'
    },
    {
        img: require('../../../images/landingpage/team-img3.png'),
        title: 'Conor Davey,',
        designation: "Co-founder & Advisor",
        points: [
            `Part of the core executive team that over 20 plus years took Williams 
            Lea from £1M to £1.4B of global revenue, latterly as Group CEO managing 10,000 plus FTEs in 33 countries`,
            'Demonstrable experience in scaling B2B services businesses in the UK and internationally.',
            `Strong track record of designing, closing and delivering long term 
            revenue agreements with large corporates and government organisations`,
            'Angel investor in early-stage businesses'
        ],
        link: 'https://www.linkedin.com/in/conor-davey-b21a10bb/'
    }
]

const FoundingTeam = () => {

    return (
        <section className="team-sec">
            {/* {<img src={require('../../images/landingpage/sphere.png')} alt='team img' className="ar pa" style={{ top: "14%", left: "-3%", }} />} */}
            <h3 className="c15 fs2-125rem fw400 mb1rem tac">The Founding Team</h3>
            <div className="df jcsb aife team-about-column">
                {TEAM_SECTION.map((obj, i, arr) => {
                    return (
                        <div className={`pr df fdc jcc w30 team-box ${i === 0 && "mt0rem"} ${i === 2 && 'mt5rem'} `}>
                            <div className="df jcc">
                                <img src={obj?.img} className="team-img " alt='team img' />
                            </div>
                            <div className="pr" >
                                <div className="card-style-about" style={{ ...cardStyle, minHeight: i === 1 ? "21rem" : '36rem' }}>
                                    <h5 className="c15 fs2rem fw500 tac lg-fs1rem xl-fs1-5rem">{obj?.title}</h5>
                                    <h6 className="c15 fs1rem fw300 lg-fs0-75rem tac mb1rem">{obj.designation}</h6>
                                    <ul>
                                        {obj?.points?.map((str, index, arr) => {
                                            return (
                                                <li key={`foundingTeamPoints${index}${index * arr.length}`} className="c14 fw400 fs0-875rem pt0-5rem pb0-5rem lg-fs0-75rem" style={{ lineHeight: "1.3rem" }}>
                                                    {str}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <LiButton link={obj?.link} />
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>

    )
}

export default FoundingTeam